import { default as TextareaAutosize } from 'react-textarea-autosize';
import { FieldInputProps, FieldMetaState, FieldRenderProps } from 'react-final-form';
import { FC } from 'react';

import { getMetaError } from 'shared/functions/errors';
import { getClassNames } from 'shared/functions/utils';

type Props = {
  input: FieldInputProps<any>;
  meta: FieldMetaState<any>;
  label?: string;
  formClass?: string;
  labelClass?: string;
  valueClass?: string;
  nullify?: boolean;
  type?: string;
  minRows?: number;
  maxRows?: number;
  placeholder?: string;
  rows?: number;
  name: string;
};

export const TextArea: FC<FieldRenderProps<any, HTMLElement, any> & Props> = ({ input, meta, ...rest }) => {
  const { label } = rest;
  const error = getMetaError(meta);

  const blurHandler = (evt) => {
    input.onBlur?.(evt);

    if (typeof input.value === 'string') {
      input.onChange?.(input.value.trim());
    }

    if (rest.nullify) {
      input.onChange?.(input.value || (rest.nullify ? null : input.value));
    }
  };

  return (
    <div data-testid={input.name} className={getClassNames('form-group', rest.formClass)}>
      <label className={getClassNames('control-label', rest.labelClass)}>{label}</label>
      <div className={getClassNames(rest.valueClass)}>
        <TextareaAutosize
          className="form-control"
          minRows={rest.minRows}
          maxRows={rest.maxRows}
          placeholder={rest.placeholder || label}
          rows={rest.rows || 1}
          {...input}
          onBlur={blurHandler}
        />
        {error && <div className="errorMsg">{error}</div>}
      </div>
    </div>
  );
};
